export const SEARCH_UNAVAILABLE_MESSAGE = "Search is currently unavailable. Please try again later.";
export const SEARCH_NO_RESULTS_MESSAGE = "No results found for your search.";

const SUSPICIOUS_PATTERN = /(--|;|\/\*|\*\/|\b(drop|select|insert|delete|update|union|alter|create)\b)/i;

export const sanitizeSearchInput = (value) => {
  const raw = String(value || "");
  const trimmed = raw.trim().replace(/\s+/g, " ");
  const cleaned = trimmed.replace(/[^a-zA-Z0-9\s\-_,.&()]/g, "").trim();
  const hasSuspiciousPattern = SUSPICIOUS_PATTERN.test(trimmed);
  const hadUnsafeChars = cleaned !== trimmed || hasSuspiciousPattern;
  const isEmpty = cleaned.length === 0;

  return {
    raw,
    cleaned,
    isEmpty,
    hadUnsafeChars,
    isValid: !isEmpty && !hasSuspiciousPattern,
  };
};

const normalize = (value) => String(value || "").toLowerCase();

export const matchesKeyword = (fields, keyword) => {
  const normalizedKeyword = normalize(keyword).trim();
  if (!normalizedKeyword) return true;

  return fields.some((field) => normalize(field).includes(normalizedKeyword));
};
